const {jQuery: $} = window;
import Utils from "./utils.class";
import Cookies from 'js-cookie';
import Cookiebot from "./CMP/Cookiebot.class";
import PardotConsent from "./PardotConsent.class";
import {iframeResize} from "iframe-resizer"
import PieChartCounter from "./components/PieChartCounter.class";
import ElementorInPageNavWidget from "./components/ElementorInPageNav.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #config;
    #scrollOffset;
    #scrollSpeed;
    #slider;
    #tabbedNav;
    #$admin;
    #root;
    #cmp;
    #counter;
    #pardotLeadCheck = false;
    constructor(
        config,
        slider,
        tabbedNav
    ) {
        this.#config = config;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.#scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('#site-wrapper');
        this.$header = $('header.elementor-location-header');
        this.#$admin = $('#wpadminbar');
        this.#slider = slider;
        this.#tabbedNav = tabbedNav;
        this.#counter = $('.counter__number');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#cmp = new Cookiebot(this.$body);
        new PardotConsent(1049322, this.#cmp);

        $(window).on(this.CMP.events.consent.marketing, () => {
            Utils.log("Showing Pardot Forms...");

            // Link to Pardot iframes
            $(".pardotFormEmbed").each((i, el) => {
                const $el = $(el);
                const utm = this.UTMs;
                const url = $el.data("url") + `&UTM_Campaign=${utm.campaign}&UTM_Source=${utm.source}&UTM_Medium=${utm.medium}&UTM_Content=${utm.content}&UTM_Term=${utm.term}&GCLID=${utm.GCLID}`;

                Utils.log($el);

                if (this.CMP.hasConsent("marketing")) {
                    $el.attr("src", url);
                }

                $el.removeClass("rcioForm__embed--loading");
            });
        });

        new PieChartCounter(this);
        new ElementorInPageNavWidget(".inPageNav--active > nav", this.headerHeight);
    }

    __onReady() {
        const me = this;
        Utils.log("Theme Ready");
        this.#updateCssHeaderHeight();

        this.#tabbedNav.events();
        // Utils.equalHeight('.kpfsc__post', '.kpf-slider-mode form > .kpfsc__posts');

        // equalHeight kpfsc__post kpfsc__posts.slick-slider

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $(document).on('click', 'a', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (hash === "#open-cmp") {
                    me.CMP.open();
                    e.preventDefault();
                    return false;
                }

                if (!Utils.scrollToHash(hash, null, me.scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function (i, el) {
            const url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if (url) {
                if (url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)) {
                    const id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1");

                    $(el).featherlight();
                }
            }
        });

        $(".rotator-text-sc").each(function (i, el) {
            const $el = $(el);
            const items = $el.data("items").split(",");
            const section = $el.parents(".elementor-element[data-element_type='container']").last();
            let first = true;

            const runner = (index = 0) => {
                if(index >= items.length) index = 0;
                const item = items[index].split("|");
                const text = item[0];
                const speed = item[1] || 5000;

                if(!first) {
                    $el.animate({opacity: 0}, 100, () => {
                        $(section).trigger('rotator_change', [$el, index, speed]);
                        $el.html(text).animate({opacity: 1}, 100);
                    });
                } else {
                    $(section).trigger('rotator_change', [$el, index, speed]);
                    $el.html(text);
                    first = false;
                }

                setTimeout(() => runner(index + 1), speed);
            };

            runner();
        });

        $(".demoRequestSc").each(function (i, el) {
            const $el = $(el);
            const $mini = $el.find(".demoRequestSc__miniForm");
            const $popup = $el.find(".demoRequestSc__popup");

            $popup.find(".demoRequestSc__popupOverlay").on("click", function (e) {
                $popup.hide();
            });

            $mini.find("button").on("click", function () {
                const email = $mini.find("input").val();
                const iframe = $popup.find(".pardotFormEmbed")[0];

                if (iframe) {
                    iframe.contentWindow.postMessage(JSON.stringify({email: email}), "https://go.partech.com");
                } else {
                    // Gravity Form (Pardot form handler): prefill its email field directly, and hide it when filled,
                    // as the Pardot layout template does. If the address fails validation, Gravity Forms re-renders
                    // the form with the field visible and its error shown.
                    const $email = $popup.find(".pardotHandlerForm input[type='email']").first();
                    $email.val(email).trigger("change");
                    $email.closest(".gfield").toggle(!email);
                }

                $popup.show();

                setTimeout(() => {
                    if(iframe && iframe.iFrameResizer) {
                        iframe.iFrameResizer.resize()
                    }
                }, 10);
            });
        });

        window.addEventListener("message", function (e) {
            if(e.origin === "https://intelligence.partech.com") {
                if(e.data.type === "demo-cta-clicked") {
                    const $popup = $(".popupFormSc");
                    const iframe = $popup.find(".pardotFormEmbed")[0];

                    $popup.show().addClass("js--visible");

                    $popup.find(".popupFormSc__popupOverlay").on("click", function (e) {
                        $popup.hide().removeClass("js--visible");
                    });

                    window.addEventListener("pardot-form-submitted", function (e) {
                        setTimeout(() => {
                            if($popup.hasClass("js--visible")) {
                                $popup.hide();
                            }
                        }, 5000);
                    });

                    setTimeout(() => {
                        if(iframe && iframe.iFrameResizer) {
                            iframe.iFrameResizer.resize()
                        }
                    }, 10);

                    window.dataLayer = window.dataLayer || [];

                    dataLayer.push({
                        event: 'par-intelligence-demo-request-cta',
                    });
                }
            }
        });

        $(".kpf-slider-mode").each(function (i, el) {
            const $el = $(el);
            const $arrowToggle = $el.data("arrows");
            const $dotToggle = $el.data("dots");
            const $speed = $el.data("speed");
            const $mobileSpeed = $el.data("mobile-speed");
            const $cycle = $el.data("cycle");
            const $tiles = $el.data("tiles");
            const $tilescroll = $el.data("tilescroll");
            const $rightArrow = '<i class="fa fas fa-chevron-right" />';
            const $leftArrow = '<i class="fa fas fa-chevron-left" />';
            // $el.css({'visibility': 'visible'});
            let $responsiveTiles;
            switch ($tiles) {
                case 3:
                    $responsiveTiles = 2;
                    break;
                case 2:
                    $responsiveTiles = 2;
                    break;
                case 1:
                    $responsiveTiles = 1;
                    break;
                default:
                    $responsiveTiles = 2;
                    break;
            }

            $el.find(".kpfsc__posts").slick({
                arrows: $arrowToggle,
                prevArrow: `<button type="button" class="slick-prev slick-custom-prev"> ${$leftArrow} </button>`,
                nextArrow: `<button type="button" class="slick-next slick-custom-next"> ${$rightArrow} </button>`,
                autoplay: $cycle,
                autoplaySpeed: $speed,
                pauseOnFocus: true,
                pauseOnHover: true,
                autoHeight: "calc",
                dots: $dotToggle,
                adaptiveHeight: false,
                infinite: true,
                slidesToScroll: $tilescroll,
                slidesToShow: $tiles,
                swipeToSlide: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: $responsiveTiles,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                            autoplaySpeed: $mobileSpeed,
                        }
                    }
                ]
            });
        });

        // Embedded Pardot iframe forms report submissions via postMessage from their layout template.
        window.addEventListener("message", (event) => {

            if (event.origin !== "https://go.partech.com") return;

            let message = false;
            try {
                message = JSON.parse(event.data);
            } catch (e) {
            }

            if (message && message.type === "pardot-form-submitted") {
                this.#handlePardotSubmission(message.formID, message.email);
            }
        });

        // Gravity Forms submitted to a Pardot form handler (kmdg-pardot-handlers) take the same path. "unconfirmed"
        // (Pardot never answered, e.g. blocked) is treated as submitted: the entry is saved and flagged for follow-up.
        window.addEventListener("kmdg-pfh:submitted", (event) => {
            const $wrapper = $(event.detail.element).closest(".pardotHandlerForm");
            this.#handlePardotSubmission($wrapper.attr("data-id"), event.detail.email, $wrapper);
        });

        // Tracking values sent with form handler submissions, only with marketing consent (as with the iframes,
        // which don't load at all without it).
        window.addEventListener("kmdg-pfh:extras", (event) => {
            if (!this.CMP.hasConsent("marketing")) return;

            const utm = this.UTMs;
            const fields = event.detail.fields;

            fields.UTM_Campaign = decodeURIComponent(utm.campaign);
            fields.UTM_Source = decodeURIComponent(utm.source);
            fields.UTM_Medium = decodeURIComponent(utm.medium);
            fields.UTM_Content = decodeURIComponent(utm.content);
            fields.UTM_Term = decodeURIComponent(utm.term);
            fields.GCLID = decodeURIComponent(utm.GCLID);
        });

        setTimeout(function () {
            const frame = iframeResize({
                log: Utils.debug,
                scrolling: false,
                checkOrigin: false
            }, ".pardotFormEmbed, .embedded-form iframe");
            setInterval(frame.resize, 1000);
        }, 1);

        $(".rcioFilterBar__filter select[name='resource-location']").on('change', function () {
            window.location.href = $(this).val();
        });

        this.#setupSearch();
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");

        this.#updateCssHeaderHeight();

        this.$header.addClass('fixed');


        const top = 1; // Trigger on any scrolling

        $(document).scroll(function () {
            
            const scrollPos = $(document).scrollTop();
            if (top && scrollPos >= top) {
                $('.elementor-location-header').addClass('scrolled');
            } else if (top && scrollPos < top) {
                $('.elementor-location-header').removeClass('scrolled');
            }
        });


        $(window).trigger("resize");

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });


        if($("#menu-wrapper").length > 0) {
            const menu = new window.Mmenu("#menu-wrapper", {
                theme: 'white',
                offCanvas: {
                    "position": "right-front",
                },
            }, {
                offCanvas: {
                    "page": {
                        "selector": "#site-wrapper"
                    }
                }
            });

            $('.mmenu-nav').on('click', function (evnt) {
                evnt.preventDefault();
                menu.API.open()
            })
        }

        //Preserve UTM codes across site browsing
        let utmParams = {};
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
        let utmString = '';
        utmKeys.forEach(key => {
            if (Utils.URLSearchParams.has(key)) {
                utmParams[key] = encodeURIComponent(Utils.URLSearchParams.get(key) || "");
                utmString += `&${key}=${utmParams[key]}`;
            }
        });

        if (Object.keys(utmParams).length > 0) {
            $("a").each(function (e) {
                let $el = $(this);
                if (location.host === $el[0].host && $el[0].hash === '') {
                    if ($el[0].search) {
                        $el.attr("href", `${$el.attr('href')}${utmString}`);
                    } else {
                        $el.attr("href", `${$el.attr('href')}${utmString.replace('&', '?')}`);
                    }
                }
            });
        }

        // Fix SVG's with embedded clip-paths
        $("svg").each(function (i, el) {
            const $el = $(el);
            const $me = $el;

            // Exclude special graphics
            if ($el.attr("id")==="flywheel" || $el.attr("id")==="infinityMap" || $el.attr("id")==="inftyMap") {return true}

            const $parent = $el.closest(".elementor-widget");
            let pathIDs = [];
            const suffix = $parent.data("id");
            const instance = i;

            $el.find("clipPath").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
            });

            $el.find("linearGradient").each((i, el) => {
                const $cp = $(el);
                let id = $cp.attr("id");
                pathIDs.push(id);
                $cp.attr("id", `${id}-${suffix}-${instance}`);
                $cp.attr("xlink:href", $cp.attr("xlink:href") + `-${suffix}-${instance}`);

                $me.find("style").each((i, el) => {
                    const $style = $(el);
                    $style.text($style.text().replaceAll(`url(#${id})`, `url(#${id}-${suffix}-${instance})`));
                });
            });

            $el.find("[class*='cls-']").each((i, el) => {
                // DOMTokenList.replace() swaps a whole token, so rename each cls-* class in turn

                [...el.classList]
                    .filter(cls => cls.startsWith("cls-"))
                    .forEach(cls => el.classList.replace(cls, `cls-${suffix}-${instance}-${cls.slice(4)}`))
            });

            $el.find("style").each((i, el) => {
                const $style = $(el);
                $style.text($style.text().replaceAll(`cls-`, `cls-${suffix}-${instance}-`));
            });

            pathIDs.forEach((val, key) => {
                $el.find(`[clip-path="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("clip-path", `url(#${val}-${suffix}-${instance})`);
                });

                $el.find(`[fill="url(#${val})"]`).each((i, el) => {
                    const $cpEL = $(el);
                    $cpEL.attr("fill", `url(#${val}-${suffix}-${instance})`);
                });

                $el.find("style").each((i, el) => {
                    const $style = $(el);
                    $style.text($style.text().replaceAll(`url(#${val})`, `url(#${val}-${suffix}-${instance})`));
                });
            });
        });

        $('.js--hide-while-loading').removeClass('js--hide-while-loading');
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    /**
     * @param {PostFilters} kpf
     * @public
     */
    __postFilters(kpf) {
        Utils.log("Theme customizations for Post Filters...");
        kpf.addFilter('post_transition_delay', () => 0)

        $(".kpfsc__filterButtons").on("click", function () {
            $("#archiveSelect").val(null);
            const dataValue = $(this).data("value");

            if (dataValue.split) {
                $("#archiveSelect").val(dataValue.split(",")).trigger('change');
            } else {
                $("#archiveSelect").val(dataValue).trigger('change');
            }
        });

    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #setupSearch() {
        function toggleClassForEls(els, theClass) {
            els.forEach((item) => {
                item.classList.toggle(theClass);
            });
        }

        const searchIcon = document.querySelectorAll('.search-menu-icon');
        const searchIconClose = document.querySelectorAll('.search-menu-icon-close');
        const searchBox = document.querySelector('#search-menu-box');

        searchIcon.forEach((item) => {
            item.addEventListener('click', () => {
                const mobileToggle = document.querySelector('.mobile-menu .elementor-menu-toggle')

                if (mobileToggle && mobileToggle.classList.contains('elementor-active')) {
                    document.querySelector('.mobile-menu .elementor-menu-toggle').click();
                }

                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').focus();
            })
        });

        searchIconClose.forEach((item) => {
            item.addEventListener('click', () => {
                searchBox.classList.toggle('isvisible');
                toggleClassForEls(searchIcon, 'isvisible');
                toggleClassForEls(searchIconClose, 'isvisible');
                document.querySelector('.elementor-search-form__input').blur();
            })
        });
    }

    get CMP() {
        return this.#cmp;
    }

    get UTMs() {
        return {
            id: encodeURIComponent(Utils.URLSearchParams.get('utm_id') || ""),
            campaign: encodeURIComponent(Utils.URLSearchParams.get('utm_campaign') || ""),
            source: encodeURIComponent(Utils.URLSearchParams.get('utm_source') || ""),
            medium: encodeURIComponent(Utils.URLSearchParams.get('utm_medium') || ""),
            term: encodeURIComponent(Utils.URLSearchParams.get('utm_term') || ""),
            content: encodeURIComponent(Utils.URLSearchParams.get('utm_content') || ""),
            GCLID: encodeURIComponent(Cookies.get("gclid") || "")
        };
    }

    /**
     * Shared by embedded Pardot iframe forms and Gravity Forms submitted to Pardot form handlers.
     *
     * @param {string|undefined} formID Placement key: the iframe's form URL, or the handler form's "gf-{id}-{n}"
     * @param {string|undefined} email
     * @param {jQuery|null} $placement The submitting placement, when known (handler forms)
     */
    #handlePardotSubmission(formID, email, $placement = null) {
        if (this.#pardotLeadCheck) return;

        window.dataLayer = window.dataLayer || [];
        this.#pardotLeadCheck = true;

        setTimeout(() => this.#pardotLeadCheck = false, 10000); // throttle duplicate messages from the same form, not sure why this happens.

        const utm = this.UTMs;

        dataLayer.push({
            event: 'pardotLead',
            pardotLead: {
                pageURL: window.location.origin + window.location.pathname,
                utm_campaign: utm.campaign,
                utm_source: utm.source,
                utm_medium: utm.medium,
                utm_term: utm.term,
                utm_content: utm.content,
                utm_id: utm.id,
                email: email || "None",
            },
        });

        // Allow for external integration
        window.dispatchEvent(new CustomEvent("pardot-form-submitted"));

        if (formID) {
            const $form = $placement && $placement.length
                ? $placement
                : $(".pardotFormEmbed, .pardotHandlerForm").filter((i, el) => el.getAttribute("data-id") === formID);
            const resource = $form.first().attr("data-resource");

            if (resource) {
                $(window).trigger('rcio_form_submitted', [email, resource, function (response) {
                    $(".rcioForm__message").filter((i, el) => el.getAttribute("data-formid") === formID).html(response);
                }]);
            }
        }
    }

    #updateCssHeaderHeight() {
        if(this.$header.length > 0) {
            this.#root.style.setProperty('--theme--header-height', this.headerHeight + "px");
            this.#root.style.setProperty('--theme--header-top', (this.$header.position().top + 20) + "px");
        }
    }
}